import React from 'react'
import { Grid, GridRow,Button, GridColumn, Header, Container, Label, Icon, Confirm,Modal } from 'semantic-ui-react'
import { connect } from 'react-redux'
import {launchDice} from '../reducers/dice/index'
import { deleteAllUsers } from '../reducers/users'
import NumPlayers from './NumPlayers'
import { launchQuestion, launchTwoWords, launchSevenWords, launchVotation, launchVotationAMaggioranza,launchSong, launchChoice, onTwoWordsEnded } from '../reducers/game'
import { resetResult } from '../reducers/result'
import NumImprovisers from './NumImprovisers'
import { checkIntegrity, initiateDB } from '../reducers/miniDB'
import {isMobile} from 'react-device-detect';


const myPath = '../assets/';
//const myPath = '  http://s3.amazonaws.com/cicciolanciabucket/assets/';

const createDiceUrl = (number) => (
    number<0?  myPath+"failed.png" : myPath+""+number+".png"
 )
 
 

export class HostPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            openConfirm : false,
            openChooseImproviser:false,
            improvisersList: []
        }
    }


    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
    }

  
    launchDice = () =>{
            this.props.onLaunchDice();
        }

    resetResult = () =>{
        this.props.onResetResult();
    }

    getDiceResult = () =>{
        this.props.onGetDiceResult();
    }

    deleteAllUser = () =>{
        this.props.onDeleteAllUser();
        this.setState({openConfirm:false})
    }

    makeAQuestion = () =>{
        this.props.onLaunchQuestion()
    }

    makeTwoWords = () =>{
        this.props.onLaunchTwoWords();
    }

    makeSong = () =>{
        this.props.onLaunchSong()
    }

    makeSevenWords = () =>{
        this.showChooseImprovser();
    }


    dumbFunction = () =>{
    }

    makeVotation = () =>{
        this.props.onResetResult();
        this.props.onLaunchVotation()
    }

    makeVotationAMaggioranza = () =>{
        this.props.onResetResult();
        this.props.onLaunchVotationAMaggioranza()
    }

    makeChoice = () =>{
        this.props.onResetResult();
        this.props.onLaunchChoice()
    }


    openConfirm = () =>{
        this.setState({openConfirm:true})
    }

    closeConfirm = () =>{
        this.setState({openConfirm:false})
    }


    checkIntegrity = () =>{
        this.props.onCheckIntegrity();
        this.props.onInitiateDB();
    }



    createButton=(nome,icona, funzione, available) =>{
        if (available)
            return(
            <Button fluid size='huge' color='green' onClick={funzione}>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name={icona} size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            {nome}
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>)
        else
        return(
            <Button fluid size='huge' color='green' disabled>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name={icona} size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            {nome}
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>
        )
    }

    createFakeButton=() =>{
        return(
            <Button fluid size='huge' color='gray' disabled>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name='x' size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            NON DISPONIBILE
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>
        )
    }
    createControlPanel = (numPlayers,numImprovisers, isMobile) =>{
        if (isMobile) return (
                <Grid Celled>
                     <GridRow>
                    <GridColumn width ={16}>
                            <Container textAlign='center'>
                                    <Button fluid size='huge' color='blue' onClick={this.resetResult}>
                                    <Icon name='eraser' size='big'/>
                                         RESETTA IL DADO</Button>
                            </Container>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                            <Header color='blue' as='h2'><Icon name='gamepad'/>{'LISTA GIOCHI'}</Header> 
                            </Container>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn >
                            <Container textAlign='center'>
                               {this.createButton('LANCIA VOTAZIONE A MAGGIORANZA', 'hand paper', this.makeVotationAMaggioranza, numPlayers>=1)}
                            </Container>
                        </GridColumn>
                        </GridRow>
                    <GridRow>
                        <GridColumn >
                            <Container textAlign='center'>
                                       {this.createButton('LANCIA IL DADO', 'sync', this.launchDice, numPlayers>=1)}
                            </Container>
                        </GridColumn>
                        </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                                      {this.createButton('LANCIA UNA DOMANDA', 'question circle', this.makeAQuestion, this.props.questionsAvailable&&(numPlayers>=1))}
                            </Container>
                        </GridColumn>
                        </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                                {this.createButton('LANCIA DUE PAROLE', 'wechat', this.makeTwoWords, this.props.twoWordsAvailable&&(numPlayers>=2))}
                                </Container>
                         </GridColumn>
                         </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                                {this.createButton('LANCIA VOTAZIONE', 'hand paper', this.makeVotation, numPlayers>=1)}
                            </Container>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                                       {this.createButton('LANCIA UNA CANZONE', 'music', this.makeSong, this.props.songAvailable&&(numPlayers>=1))}
                            </Container>
                        </GridColumn>
                        </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                                      {this.createButton('FAI SCEGLIERE A LORO', 'thermometer', this.makeChoice, numPlayers>=1)}
                            </Container>
                        </GridColumn>
                        </GridRow>
                    <GridRow>
                        <GridColumn>
                            <Container textAlign='center'>
                             {this.createButton('LANCIA SEVEN WORDS', 'puzzle', this.makeSevenWords, this.props.sevenWordsAvailable
                                                                                                            && ((numPlayers>=8) || ((numPlayers>=7) && (numImprovisers>=1))))}
                            </Container>
                         </GridColumn>
                    </GridRow>
                </Grid>)
        else return (
            <Grid Celled>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                        <Header color='blue' as='h2'><Icon name='gamepad'/>{'LISTA GIOCHI'}</Header> 
                        </Container>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                                   {this.createButton('LANCIA IL DADO', 'sync', this.launchDice, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                                  {this.createButton('LANCIA UNA DOMANDA', 'question circle', this.makeAQuestion, this.props.questionsAvailable&&(numPlayers>=1))}
                        </Container>
                    </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                            {this.createButton('LANCIA DUE PAROLE', 'wechat', this.makeTwoWords, this.props.twoWordsAvailable&&(numPlayers>=2))}
                            </Container>
                     </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                            {this.createButton('LANCIA VOTAZIONE', 'hand paper', this.makeVotation, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                                   {this.createButton('LANCIA UNA CANZONE', 'music', this.makeSong, this.props.songAvailable&&(numPlayers>=1))}
                        </Container>
                    </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                                  {this.createButton('FAI SCEGLIERE A LORO', 'thermometer', this.makeChoice, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                         {this.createButton('LANCIA SEVEN WORDS', 'puzzle', this.makeSevenWords, this.props.sevenWordsAvailable
                                                                                                        && ((numPlayers>=8) || ((numPlayers>=7) && (numImprovisers>=1))))}
                        </Container>
                     </GridColumn>
                    <GridColumn width ={4}>
                        <Container textAlign='center'>
                         {this.createButton('LANCIA VOTAZIONE A MAGGIORANZA', 'hand paper', this.makeVotationAMaggioranza, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                </GridRow>

                <GridRow>
                <GridColumn width ={16}>
                        <Container textAlign='center'>
                                <Button fluid size='huge' color='blue' onClick={this.resetResult}>
                                <Icon name='eraser' size='big'/>
                                     RESETTA IL DADO</Button>
                        </Container>
                    </GridColumn>
                </GridRow>
            </Grid>
        )
    }


    handleImproviserClick= (e) =>{
        if (e.target.value=='nessuno'){
            this.hideChooseImprovser();
            this.props.onLaunchSevenWords(null);
        }else{
            this.hideChooseImprovser();
            this.props.onLaunchSevenWords(e.target.value);
        }
    }


    improviserBox = (item) =>{

        return (
            <GridRow>
                <GridColumn>
                    <Container textAlign='center'>
                        <Button color='black' fluid onClick={this.handleImproviserClick} value={item.user_id}> {item.user_name}</Button>
                    </Container>
            </GridColumn>
            </GridRow>
        )
    }

    createChoosImprovser = () =>{
        return(
            <Grid Celled>
                    {this.props.improvisersIds?this.props.improvisersIds.map((item)=> this.improviserBox(item)):""}
                    <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                            <Button color='black' fluid onClick={this.handleImproviserClick} value={'nessuno'}>NESSUNO</Button>
                        </Container>
                    </GridColumn>
                    </GridRow>
                    <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                            <Button color='red' fluid onClick={this.hideChooseImprovser}>CHIUDI</Button>
                        </Container>
                    </GridColumn>
                    </GridRow>
            </Grid>
        )
    }

    showChooseImprovser = () =>{
        this.setState({openChooseImproviser:true})
    }

    hideChooseImprovser = () =>{
        this.setState({openChooseImproviser:false})
    }

    twoWordsEnded = () =>{
        this.props.onTwoWordsEnded();
    }


    render() {
        const { result, selectedName,selectedName2,numPlayers, numImprovisers, numberOfEnded, gameType} = this.props
        if (gameType == 2 && numberOfEnded == 2){ 
            this.twoWordsEnded();
        }
        if (isMobile){
            return(
                <Grid centered verticalAlign='middle' celled>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                    <Header color='red' as='h2'>{'PANNELLO DI CONTROLLO'}</Header> 
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow>
                <GridColumn>    
                    <Container textAlign='center'>
                        <Grid>
                        <GridColumn centered>    
                        <GridRow>
                        <Container textAlign='center'>
                            <img src={createDiceUrl(result)} width="200"/><br/>
                            </Container>
                            </GridRow>
                            <GridRow>
                            <Container textAlign='center'>
                            {selectedName?
                                <Label size='big'>
                                    {selectedName} {}
                                </Label>
                            :                               
                            <Label size='big'>WAIT</Label>
                            }
                            </Container>
                            </GridRow>
                        <GridRow>
                        <Container textAlign='center'>
                        {selectedName2!=undefined?
                                <Label size='big'>
                                    {selectedName2}
                                </Label>
                            :                               
                            ""
                            }
                            </Container>
                            </GridRow>
                        </GridColumn>
                        </Grid>
                        </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered>
                        <Grid centered verticalAlign='middle' celled>
                            <GridRow>
                                <GridColumn>
                                {this.state.openChooseImproviser?
                                this.createChoosImprovser()
                                :this.createControlPanel(numPlayers, numImprovisers, isMobile)
                                }
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                        <NumPlayers />
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                        <NumImprovisers />
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn>
                        <Container textAlign='center'>
                        {this.props.dbIntegrity==undefined?
                            <Button size='huge' fluid color='yellow' onClick={this.checkIntegrity}>
                            <Icon name='database'/>CHECK INTEGRITY DATABASE</Button>
                        :this.props.dbIntegrity?
                        <Button size='huge' fluid color='green' disabled>
                        <Icon name='database'/>INTEGRITY DATABASE CHECKED</Button>
                        :<Button size='huge' fluid color='red' disabled> 
                        <Icon name='database'/>INTEGRITY DATABASE FAILED</Button>
                        }
                    </Container>
                    </GridColumn>
                    </GridRow>
                <GridRow centered>
                    <GridColumn>
                    <Container textAlign='center'>
                            <Confirm
                                    open={this.state.openConfirm}
                                    onCancel={this.closeConfirm}
                                    onConfirm={this.deleteAllUser}
                                    content='Sei sicuro di voler cancellare tutti gli utenti?'
                                    cancelButton='No, ci ho ripensato'
                                    confirmButton="Sì, certo che sì"
                        
                            />
                            <Button fluid size='huge' color='red' onClick={this.openConfirm}>
                            <Icon name='trash'/>
                            CANCELLA TUTTI GLI UTENTI</Button>
                    </Container>
                    </GridColumn>
                </GridRow>
            </Grid>)
        }else  return(
            <Grid centered verticalAlign='middle' celled>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                    <Header color='red' as='h2'>{'PANNELLO DI CONTROLLO'}</Header> 
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered  width={13}>
                        <Grid centered verticalAlign='middle' celled>
                            <GridRow>
                                <GridColumn>
                                {this.state.openChooseImproviser?
                                this.createChoosImprovser()
                                :this.createControlPanel(numPlayers, numImprovisers)
                                }
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </GridColumn>
                    <GridColumn  width={3}>    
                    <Container textAlign='center'>
                        <Grid>
                          <GridColumn width={16} centered>    
                          <GridRow>
                          <Container textAlign='center'>
                              <img src={createDiceUrl(result)} width="200"/><br/>
                              </Container>
                              </GridRow>
                            <GridRow>
                            <Container textAlign='center'>
                            {selectedName?
                                <Label size='big'>
                                    {selectedName} {}
                                </Label>
                            :                               
                               <Label size='big'>WAIT</Label>
                            }
                            </Container>
                            </GridRow>
                           <GridRow>
                           <Container textAlign='center'>
                           {selectedName2!=undefined?
                                <Label size='big'>
                                    {selectedName2}
                                </Label>
                            :                               
                              ""
                            }
                            </Container>
                            </GridRow>
                          </GridColumn>
                        </Grid>
                          </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                         <NumPlayers />
                         <NumImprovisers />
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn width={3}>
                        <Container textAlign='center'>
                        {this.props.dbIntegrity==undefined?
                            <Button size='huge' color='yellow' onClick={this.checkIntegrity}>
                            <Icon name='database'/>CHECK INTEGRITY DATABASE</Button>
                        :this.props.dbIntegrity?
                        <Label size='huge' color='green'>
                        <Icon name='database'/>INTEGRITY DATABASE CHECKED</Label>
                        :<Label size='huge' color='red'>
                        <Icon name='database'/>INTEGRITY DATABASE FAILED</Label>
                        }
                    </Container>
                    </GridColumn>
                    <GridColumn width={10}>
                    </GridColumn>
                    <GridColumn  width={3}>
                    <Container textAlign='center'>
                             <Confirm
                                    open={this.state.openConfirm}
                                    onCancel={this.closeConfirm}
                                    onConfirm={this.deleteAllUser}
                                    content='Sei sicuro di voler cancellare tutti gli utenti?'
                                    cancelButton='No, ci ho ripensato'
                                    confirmButton="Sì, certo che sì"
                          
                             />
                             <Button fluid size='huge' color='red' onClick={this.openConfirm}>
                             <Icon name='trash'/>
                             CANCELLA TUTTI GLI UTENTI</Button>
                    </Container>
                    </GridColumn>
                </GridRow>
            </Grid>
              
        )
    }
}

const mapStateToProps = (state, {}) => ({
    gameType: state.game.gameType,
    selectedName: state.selected.selected,
    selectedName2: state.selected.selected2,
    msToAnswer: state.game.msToAnswer,
    result: state.result!=0?state.result.result:0,
    songAvailable: state.miniDB?state.miniDB.songAvailable:false,
    questionsAvailable: state.miniDB?state.miniDB.questionsAvailable:false,
    twoWordsAvailable: state.miniDB?state.miniDB.twoWordsAvailable:false,
    sevenWordsAvailable: state.miniDB?state.miniDB.sevenWordsAvailable:false,
    dbIntegrity: state.miniDB?state.miniDB.dbIntegrity:-1,
    numPlayers: state.numPlayers,
    numImprovisers:state.numImprovisers,
    improvisersIds:state.users.improvisersIds,
    numberOfEnded: state.game.numberOfEnded
})

const mapDispatchToProps = (dispatch, { socket}) => ({
    onLaunchDice:()=> dispatch(launchDice(socket)),
    onResetResult:()=> dispatch(resetResult(socket)),
    onDeleteAllUser:()=>dispatch(deleteAllUsers(socket)),
    onLaunchQuestion:()=>dispatch(launchQuestion(socket)),
    onLaunchTwoWords:()=>dispatch(launchTwoWords(socket)),
    onLaunchSevenWords:(improviser)=>dispatch(launchSevenWords(socket, improviser)),
    onLaunchVotation:()=>dispatch(launchVotation(socket)),
    onLaunchVotationAMaggioranza:()=>dispatch(launchVotationAMaggioranza(socket)),
    onLaunchSong:()=>dispatch(launchSong(socket)),
    onLaunchChoice:()=>dispatch(launchChoice(socket)),
    onCheckIntegrity:()=>dispatch(checkIntegrity(socket)),
    onInitiateDB:()=>dispatch(initiateDB(socket)),
    onTwoWordsEnded:()=>dispatch(onTwoWordsEnded(socket))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HostPage)


// WEBPACK FOOTER //
// ./src/components/HostPage.js